import styled from 'styled-components';
import { useSearchFilters } from '../../../../common/components/SearchHeader/filters/useSearchFilters';
import { FilterPill } from '../../FilterPill/FilterPill';

interface Props {
  handleOptionClear: (filterKey: string) => void;
  className?: string;
}

export const FilterSummary = ({ handleOptionClear, className }: Props) => {
  const [filters] = useSearchFilters();

  return (
    <FilterSummaryContainer className={className}>
      {filters.language && (
        <StyledFilterPill
          hasValue={Boolean(filters.language)}
          onClear={() => handleOptionClear('language')}
          valueCaption={filters.language}
        />
      )}
      {filters.paymentMethod && (
        <StyledFilterPill
          hasValue={Boolean(filters.paymentMethod)}
          onClear={() => handleOptionClear('paymentMethod')}
          valueCaption={filters.paymentMethod}
        />
      )}
      {filters.governmentScheme && (
        <StyledFilterPill
          hasValue={Boolean(filters.governmentScheme)}
          onClear={() => handleOptionClear('governmentScheme')}
          valueCaption={filters.governmentScheme}
        />
      )}
    </FilterSummaryContainer>
  );
};

const FilterSummaryContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
`;

const StyledFilterPill = styled(FilterPill)`
  margin: 4px 8px 0 0;
  max-width: 190px;
`;
